__turbopack_context__.v({
  "card": "TepedW_card",
  "static": "TepedW_static",
  "wrapper": "TepedW_wrapper",
});
